module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectBps":"Select business processes","close":"Close","accept":"Accept"},"es":{"selectBps":"Seleccione procesos de negocio","close":"Cerrar","accept":"Acceptar"}}')
  delete Component.options._Ctor
}
